import { Box } from "@mui/system";
import { Tooltip, Typography } from "@mui/material";

import { useTranslate } from "src/locales";
import { MeetingPlatform } from "src/services/meetings/meetings.types";

import Iconify from "src/components/iconify";

export function MeetingPlatformIcon({ platform, withLabel = false }: { platform: MeetingPlatform, withLabel?: boolean }) {

  const { t } = useTranslate();

  const getLabel = () => {
    switch (platform) {
      case MeetingPlatform.ZOOM:
        return t('enums.meeting_platform.zoom');
      case MeetingPlatform.GOOGLE_MEET:
        return t('enums.meeting_platform.google_meet');
      case MeetingPlatform.MICROSOFT_TEAMS:
        return t('enums.meeting_platform.microsoft_teams');
      case MeetingPlatform.NATIVE:
        return t('enums.meeting_platform.native');
      default:
        return t('common.unknown');
    }
  };

  const getPlatformIcon = () => {
    switch (platform) {
      case MeetingPlatform.ZOOM:
        return <Iconify icon='logos:zoom' width={24} height={24} />
      case MeetingPlatform.GOOGLE_MEET:
        return <Iconify icon='logos:google-meet' width={24} height={24} />
      case MeetingPlatform.MICROSOFT_TEAMS:
        return <Iconify icon='logos:microsoft-teams' width={24} height={24} />
      case MeetingPlatform.NATIVE:
        return <Box
          component="img"
          src="/assets/logo/logo-icon.svg"
          sx={{ width: 24, height: 24 }}
        />
      default:
        return <Box
          component="img"
          src="/assets/logo/logo-icon.svg"
          sx={{ width: 24, height: 24 }}
        />
    }
  };

  return (
    <Tooltip title={t(`enums.meeting_platform.${platform}`)} arrow>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {getPlatformIcon()}
        {withLabel && (
          <Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>
            {getLabel()}
          </Typography>
        )}
      </Box>

    </Tooltip>

  )
}
